import InstrumentDropdownIcon from './InstrumentDropdownIcon';

export default InstrumentDropdownIcon;
